import script from "./CampusMap.vue?vue&type=script&setup=true&lang=js"
export * from "./CampusMap.vue?vue&type=script&setup=true&lang=js"

import "./CampusMap.vue?vue&type=style&index=0&id=311ea267&lang=css"

const __exports__ = script;

export default __exports__